import { useLifecyclePersistence, useSyncLifecycleToExistingAtom } from '../../utilities'
import { CampaignForm } from '../../views'
import { formAtom, formSavingAtom, formStatusAtom, useFormListener } from '../state'

export type UseFormEditorArguments = {
	form: CampaignForm | undefined
	isPending: boolean
	isSaving: boolean
	isGenerating: boolean
	isToolExecuting?: boolean
	onFormChange: (form: CampaignForm) => void
	formVersion?: number | string | Date | null
}

export function useFormEditor({
	form,
	isPending,
	isSaving,
	isGenerating,
	isToolExecuting = false,
	onFormChange,
	formVersion,
}: UseFormEditorArguments) {
	const formLifecycle = useLifecyclePersistence<CampaignForm>({
		data: form ?? undefined,
		isIdle: (d) => d == undefined,
		isPending: () => isPending,
		isGenerating: () => isGenerating,
		isToolExecuting,
		save: async (formData) => {
			console.log('useFormEditor.save', formData)
			await onFormChange(formData)
		},
		debounceMs: 800,
		getVersion: () => formVersion ?? null,
		debug: false,
		name: 'useFormEditor',
	})

	useSyncLifecycleToExistingAtom(
		formLifecycle,
		{
			dataAtom: formAtom,
			useDataListener: useFormListener,
			lifecycleAtom: formStatusAtom,
			persistenceAtom: formSavingAtom,
		},
	)
}
